// extracted by mini-css-extract-plugin
export default {"sidebarHeader":"SidebarHeader_sidebarHeader__Xx-6e"};